module.exports = __webpack_public_path__ + "img/nav-trade.a6c0418.svg";